// Skill manifest extension point: a skill authored in the customer repo.
//
// Related to `OpenCodeConfigSkillSchema` in ../contracts/me.ts, but not identical: the
// wire contract carries server-computed bundle facts (`bundleUrl`, `bundleSha256`,
// `bundleSizeBytes`), while the CONFIG declares only what a human writes — the name and
// the source directory. `pack` bundles the directory, and `admin apply` uploads it, so
// the computed fields appear later, on the wire.
import { z } from 'zod';
export const SkillManifestSchema = z.strictObject({
    /** Registered name — the natural key for apply. */
    name: z.string().min(1),
    description: z.string().min(1).optional(),
    /** Source directory of the skill inside the customer repo. */
    path: z.string().regex(/^extensions\/skills\/[a-z][a-z0-9-]*$/, 'must be extensions/skills/<name>'),
    /** Optional customer-side version, surfaced in the admin UI. */
    version: z.string().min(1).optional(),
});
//# sourceMappingURL=skill-manifest.js.map